let sent = 0;

export function reportClientError(source, error, extra) {
  if (sent >= 10) return;
  sent += 1;
  try {
    const body = JSON.stringify({
      source,
      message: String((error && (error.message || error)) || "unknown").slice(0, 1000),
      stack: String((error && error.stack) || "").slice(0, 4000),
      extra: String(extra || "").slice(0, 4000),
      url: window.location.href,
      ua: navigator.userAgent,
    });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/client-errors`;
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }));
    else fetch(url, { method: "POST", headers: { "Content-Type": "text/plain" }, body, keepalive: true });
  } catch {
    // ignore
  }
}
